import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";

export const marginBottomCSS = css`
    margin-bottom: ${Spacing.LG}px;
`;
